import {
  makeStyles,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Drawer,
  DialogTitle,
  Typography,
} from "@material-ui/core";
import { FC } from "react";
import { ModalWindow } from "components/templateComponents/modalWindow";
import { useDialogStyles } from "components/modals/styles";
import { fileUploadButtons } from "./buttonLists";

interface ImportFileDrawerProps {
  open: boolean;
  onClose: () => void;
}

interface BtnListItem {
  modalName: string;
  modalTitle: string;
  modalDescription: string;
  component: JSX.Element;
}

interface BtnListComponentProps {
  list: BtnListItem[];
  className: string;
}

export const ImportFileDrawer: FC<ImportFileDrawerProps> = ({ open, onClose }) => {
  const dialogClasses = useDialogStyles();
  const classes = useFiltersStyles();

  return (
    <Drawer
      data-testid="importFileDrawer"
      anchor="right"
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{ style: { maxWidth: 400 } }}
    >
      <DialogTitle id="alert-dialog-title">
        <Typography variant="h4" style={{ textAlign: "center", fontWeight: 700 }}>Upload Report</Typography>
      </DialogTitle>
      <DialogContent>
        <BtnListComponent list={fileUploadButtons} className={classes.btnList} />
      </DialogContent>
      <DialogActions style={{ padding: "32px 24px", gap: "20px" }}>
        <Button
          data-testid="importFileDrawerCancelButton"
          className={dialogClasses.actionButton}
          onClick={onClose}
        >
          Cancel
        </Button>
      </DialogActions>
    </Drawer>
  );
};

export const BtnListComponent = ({ list, className }: BtnListComponentProps) => {
  return (
    <Box className={className} data-testid="importBtnListComponent">
      {list?.map((item: BtnListItem) => (
        <ModalWindow
          buttonType={"text"}
          modal_name={item.modalName}
          modalTitle={item.modalTitle}
          modalDescription={item.modalDescription}
        >
          {item.component}
        </ModalWindow>
      ))}
    </Box>
  );
};

const useFiltersStyles = makeStyles((theme) => ({
  btnList: {
    boxSizing: "border-box",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    paddingTop: theme.spacing(2),
    gap: theme.spacing(3),
  },
}));
